<template>
    <div class="record-box data-box" :class="obj.recordno == 0 ? 'disabled-box' : ''">
        <el-row :gutter="20">
            <el-col :span="cols">
                <span class="label-span" tkey="公司名稱">{{i18n.tkey("lang_company_name")}}:&nbsp;</span>
                <span class="content-span">{{obj.companyname}}</span>
            </el-col>

            <el-col :span="cols">
                <span class="label-span" tkey="公司名稱(英文)">{{i18n.tkey("lang_company_name_eng")}}:&nbsp;</span>
                <span class="content-span">{{obj.companyname2}}</span>
            </el-col>

            <el-col :span="cols">
                <span class="label-span" tkey="門牌號">{{i18n.tkey("lang_doornum_text")}}:&nbsp;</span>
                <span class="content-span">{{obj.addinfo1}} - {{obj.addinfo2}}</span>
            </el-col>

            <el-col :span="cols">
                <span class="label-span" tkey="地區">{{i18n.tkey("lang_area_text")}}:&nbsp;</span>
                <span class="content-span">{{obj.countryname}}</span>
            </el-col>

            <el-col :span="24">
                <div style="text-align: right">
                    <el-button
                        type="danger"
                        @click="clickDisable"
                        v-if="obj.recordno == -1"
                    >
                        <span tkey="禁用">{{i18n.tkey("lang_disable")}}</span>
                    </el-button>

                    <el-button
                        type="success"
                        @click="clickEnable"
                        v-if="obj.recordno == 0"
                    >
                        <span tkey="啟用">{{i18n.tkey("lang_enable")}}</span>
                    </el-button>

                    <el-button
                        type="primary"
                        @click="clickEdit"
                    >
                        <span tkey="修改">{{i18n.tkey("lang_modify")}}</span>
                    </el-button>
                </div>
            </el-col>
        </el-row>

    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount} from "vue";
import myUtil from "@/util/util";

const props = defineProps(["obj"])
const emits = defineEmits(["clickEdit", "clickEnable", "clickDisable"])

const i18n = inject("i18n")
const cols = ref(24)

function clickDisable(){
    emits("clickDisable", props.obj)
}

function clickEnable(){
    emits("clickEnable", props.obj)
}

function clickEdit(){
    emits("clickEdit", props.obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }
})

</script>

<style scoped>

.record-box{
    width: 100%;
    text-align: left;
    box-sizing: border-box;
    padding: 10px;
    border: 1px #F5F7FA solid;
    border-radius: 3px;
}

.data-ul {
    list-style: none;
    padding-left: 0;
}

.label-span {
    color: #606266;
}

.content-span {
    color: #606266;
}

.data-box {
    line-height: 2;
    font-size: 14px;
    text-align: left;
}

.operation-box {
    margin-top: 20px;
    text-align: center;
}

.disabled-box {
    background: #fef0f0;
}

</style>